import { OrderType, PaymentMethod, ProductCode } from "~/common/constants"

export type PurchaseSelection = {
  intent: API.Payment.CreateOrReusePaymentParams
  originalAmount: number
  successDescription: string
  successTitle: string
}

export const PROFESSIONAL_PLAN = {
  points: 300,
  price: 69,
  originalPrice: 99,
} as const

export const PROFESSIONAL_UPGRADE: PurchaseSelection = {
  intent: {
    payment_method: PaymentMethod.wechat,
    order_type: OrderType.levelPackage,
    product_code: ProductCode.proMonthlyV1,
  },
  originalAmount: PROFESSIONAL_PLAN.originalPrice * 100,
  successDescription: `每月${PROFESSIONAL_PLAN.points}积点等专业版权益已到账`,
  successTitle: "专业版开通成功",
}
